"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'HikeBenchmarkScoreChecking',
  data: function data() {
    return {
      dialogVisible: false,
      dialogAddScoreVisible: false,
      dialogEditScoreVisible: false,
      dialogVideoPlayerVisible: false,
      dialogEditCommentVisible: false,
      dialogRemoveScoreVisible: false,
      dialogRemoveConfirmScoreVisible: false,
      dialogVideoTitle: '',
      dialogVideoUrl: '',
      scoreToEdit: {},
      scoreToAdd: {},
      raterToRemove: {},
      fullscreenloading: false,
      hike: null,
      stages: [],
      myHikeTeams: [],
      activeNames: [],
      activeName: 'user0',
      scoreData: [],
      raterData: {},
      didWell: '',
      forImprovement: '',
      newDidWell: '',
      newForImprovement: '',
      commentData: {},
      spiderData: [],
      tabLoading: false,
      reportType: '',
      autoOverallTagsTitle: 'Overall',
      autoOverallTagList: [],
      autoVideoTagsTitle: 'Video',
      autoVideoTagsList: [],
      sort: true //default asc
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var id;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            id = typeof _this.$route.params.id === 'undefined' ? '' : _this.$route.params.id;
            _this.reportType = _this.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
            _context.n = 1;
            return _this.getHike();
          case 1:
            _context.n = 2;
            return _this.getHikeParticipants();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['uuid'])),
  methods: {
    checkPermission: _permission.default,
    getHike: function getHike() {
      var _this2 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeById)(token, id).then(function (response) {
        _this2.hike = response.data;
        if (_this2.hike.stages) {
          for (var i = 0; i < _this2.hike.stages.length; i++) {
            if (_this2.hike.stages[i].type === _this2.reportType) {
              _this2.stages.push(_this2.hike.stages[i]);
            }
          }
        }
        _this2.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getHikeParticipants: function getHikeParticipants() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, id;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              id = typeof _this3.$route.params.id === 'undefined' ? '' : _this3.$route.params.id;
              _context2.n = 1;
              return (0, _hike.getParticipant)(token, id).then(function (response) {
                var participants = response.data.rows;
                _this3.myHikeTeams = participants.map(function (p) {
                  return _lodash.default.pick(p, ['uuid', 'familyName', 'givenName', 'email']);
                });
                console.log('My Teams', _this3.myHikeTeams);
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getReport: function getReport(hikeId, stageId, uuid) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token, userScore;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              userScore = null;
              _context3.n = 1;
              return (0, _hike.scoreCheckingReport)(token, hikeId, stageId, uuid, _this4.reportType).then(function (response) {
                userScore = response.data;
                // console.log('userScore', userScore)
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
              });
            case 1:
              return _context3.a(2, userScore);
          }
        }, _callee3);
      }))();
    },
    handleAddScoreClick: function handleAddScoreClick(scoreConfig, actionInfo) {
      this.scoreToAdd = _lodash.default.cloneDeep({
        "score": scoreConfig.map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            'score': 1
          });
        }).filter(function (v) {
          return v.enable;
        }),
        "info": actionInfo
      });
      this.dialogAddScoreVisible = true;
    },
    saveAdd: function saveAdd() {
      var _this5 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var token, body, overallBody, mappedResult;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this5.tabLoading = true;
              body = {
                "rater": _this5.uuid,
                "actionWeight": _this5.scoreToAdd.info.weight,
                "results": _this5.scoreToAdd.score
              };
              _this5.dialogAddScoreVisible = false;
              if (!(_this5.hike.skillCompassDimensions === "auto")) {
                _context4.n = 4;
                break;
              }
              if (!(typeof _this5.scoreToAdd.info.actionId === 'undefined')) {
                _context4.n = 2;
                break;
              }
              overallBody = {
                "scores": _this5.scoreToAdd.score,
                "didWell": _this5.scoreToAdd.info.didWell,
                "forImprovement": _this5.scoreToAdd.info.forImprovement
              };
              _context4.n = 1;
              return (0, _hike.addUserOverallScore)(token, _this5.scoreToAdd.info.hike.id, _this5.scoreToAdd.info.stage, _this5.scoreToAdd.info.userUuid, _this5.scoreToAdd.info.type, overallBody).then(function (response) {
                _this5.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
                _this5.handleChange(_this5.scoreToAdd.info.userUuid);
              }).catch(function (error) {
                _this5.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 1:
              _context4.n = 3;
              break;
            case 2:
              mappedResult = _this5.scoreToAdd.score.map(function (v) {
                return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
                  'weight': v['rate']
                });
              });
              body['results'] = mappedResult;
              _context4.n = 3;
              return (0, _hike.addUserScoreNew)(token, _this5.scoreToAdd.info.hike.id, _this5.scoreToAdd.info.stage, _this5.scoreToAdd.info.userUuid, _this5.scoreToAdd.info.type, _this5.scoreToAdd.info.actionId, body).then(function (response) {
                _this5.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
                _this5.handleChange(_this5.scoreToAdd.info.userUuid);
              }).catch(function (error) {
                _this5.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 3:
              _context4.n = 5;
              break;
            case 4:
              _context4.n = 5;
              return (0, _hike.addUserScore)(token, _this5.scoreToAdd.info.hike, _this5.scoreToAdd.info.stage, _this5.scoreToAdd.info.userUuid, _this5.scoreToAdd.info.type, _this5.scoreToAdd.info.actionId, body).then(function (response) {
                _this5.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been added successfully!", "success");
                _this5.handleChange(_this5.scoreToAdd.info.userUuid);
              }).catch(function (error) {
                _this5.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    showRemoveRaterScoresAlert: function showRemoveRaterScoresAlert(raterUuid, info) {
      var _this6 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this6.raterToRemove = {
                'raterUuid': raterUuid,
                'raterName': info.raterName,
                'userUuid': info.userUuid,
                'stage': info.stage,
                'type': info.type
              };
              _this6.dialogRemoveConfirmScoreVisible = false;
              _this6.dialogRemoveScoreVisible = true;
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    showConfirmRemoveRaterScores: function showConfirmRemoveRaterScores() {
      this.dialogRemoveConfirmScoreVisible = true;
      this.dialogRemoveScoreVisible = false;
    },
    handleRemoveRaterScores: function handleRemoveRaterScores() {
      var _this7 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var token;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this7.dialogRemoveConfirmScoreVisible = false;
              _this7.dialogRemoveScoreVisible = false;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _context6.n = 1;
              return (0, _hike.removeScores)(token, _this7.hike.id, _this7.raterToRemove.stage, _this7.raterToRemove.userUuid, _this7.raterToRemove.type, _this7.raterToRemove.raterUuid).then(function (response) {
                _this7.tabLoading = false;
                (0, _log.displayPopupMessage)('Score has been deleted successfully!', 'success');
                _this7.handleChange(_this7.raterToRemove.userUuid);
              }).catch(function (error) {
                _this7.tabLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    showEditRaterCommentAlert: function showEditRaterCommentAlert() {
      this.newDidWell = _lodash.default.cloneDeep(this.didWell);
      this.newForImprovement = _lodash.default.cloneDeep(this.forImprovement);
      this.dialogEditCommentVisible = true;
    },
    handleEditRaterComments: function handleEditRaterComments() {
      var _this8 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var token;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this8.dialogEditCommentVisible = false;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _context7.n = 1;
              return (0, _hike.editComments)(token, _this8.commentData.id, {
                'didWell': _this8.newDidWell,
                'forImprovement': _this8.newForImprovement
              }).then(function (response) {
                _this8.tabLoading = false;
                (0, _log.displayPopupMessage)('Comments have been updated successfully!', 'success');
                _this8.handleChange(_this8.commentData.userUuid);
              }).catch(function (error) {
                _this8.tabLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handlePlayClick: function handlePlayClick(playInfo) {
      var _this9 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var token;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this9.tabLoading = true;
              _context8.n = 1;
              return (0, _hike.getVideoUrl)(token, playInfo.content.id).then(function (response) {
                _this9.tabLoading = false;
                _this9.dialogVideoUrl = response.data.url;
                _this9.dialogVideoPlayerVisible = true;
                _this9.dialogVideoTitle = playInfo.title;
              }).catch(function (error) {
                _this9.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    handleEditScoreClick: function handleEditScoreClick(score, actionInfo) {
      this.scoreToEdit = _lodash.default.cloneDeep({
        "score": score,
        "info": actionInfo
      });
      this.dialogEditScoreVisible = true;
    },
    saveEdit: function saveEdit() {
      var _this0 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var token, body;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              // console.log(this.hike.skillCompassDimensions)
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this0.tabLoading = true;
              body = {
                "rater": _this0.scoreToEdit.info.raterId,
                "results": _this0.scoreToEdit.score
              };
              _this0.dialogEditScoreVisible = false;
              if (!(_this0.hike.skillCompassDimensions === "auto")) {
                _context9.n = 4;
                break;
              }
              if (!(typeof _this0.scoreToEdit.info.actionId === 'undefined')) {
                _context9.n = 2;
                break;
              }
              _context9.n = 1;
              return (0, _hike.updateUserOverallScore)(token, _this0.scoreToEdit.info.hike.id, _this0.scoreToEdit.info.stage, _this0.scoreToEdit.info.userUuid, body).then(function (response) {
                _this0.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
                _this0.handleChange(_this0.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this0.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 1:
              _context9.n = 3;
              break;
            case 2:
              _context9.n = 3;
              return (0, _hike.updateUserScoreNew)(token, _this0.scoreToEdit.info.hike.id, _this0.scoreToEdit.info.stage, _this0.scoreToEdit.info.userUuid, _this0.scoreToEdit.info.actionId, body).then(function (response) {
                _this0.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
                _this0.handleChange(_this0.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this0.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 3:
              _context9.n = 5;
              break;
            case 4:
              _context9.n = 5;
              return (0, _hike.updateUserScore)(token, _this0.scoreToEdit.info.hike, _this0.scoreToEdit.info.stage, _this0.scoreToEdit.info.userUuid, _this0.scoreToEdit.info.actionId, body).then(function (response) {
                _this0.tabLoading = false;
                var userScore = response.data.scores;
                (0, _log.displayPopupMessage)("Score has been updated successfully!", "success");
                _this0.handleChange(_this0.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this0.tabLoading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });
            case 5:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    handleDeleteScoreClick: function handleDeleteScoreClick(score, actionInfo) {
      var _this1 = this;
      this.scoreToEdit = _lodash.default.cloneDeep({
        "score": score,
        "info": actionInfo
      });
      this.$confirm("This score will be deleted. Continue?", 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this1.deleteScore();
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    deleteScore: function deleteScore() {
      var _this10 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
        var token;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this10.tabLoading = true;
              if (!(_this10.hike.skillCompassDimensions === "auto")) {
                _context0.n = 4;
                break;
              }
              if (!(typeof _this10.scoreToEdit.info.actionId === 'undefined')) {
                _context0.n = 2;
                break;
              }
              _context0.n = 1;
              return (0, _hike.deleteUserOverallScore)(token, _this10.scoreToEdit.info.hike.id, _this10.scoreToEdit.info.stage, _this10.scoreToEdit.info.userUuid, _this10.scoreToEdit.info.raterId).then(function (response) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
                _this10.handleChange(_this10.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              _context0.n = 3;
              break;
            case 2:
              _context0.n = 3;
              return (0, _hike.deleteUserScoreNew)(token, _this10.scoreToEdit.info.hike.id, _this10.scoreToEdit.info.stage, _this10.scoreToEdit.info.userUuid, _this10.scoreToEdit.info.actionId, _this10.scoreToEdit.info.raterId).then(function (response) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
                _this10.handleChange(_this10.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 3:
              _context0.n = 5;
              break;
            case 4:
              _context0.n = 5;
              return (0, _hike.deleteUserScore)(token, _this10.scoreToEdit.info.hike, _this10.scoreToEdit.info.stage, _this10.scoreToEdit.info.userUuid, _this10.scoreToEdit.info.actionId, _this10.scoreToEdit.info.raterId).then(function (response) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)("Score has been deleted successfully!", 'success');
                _this10.handleChange(_this10.scoreToEdit.info.userUuid);
              }).catch(function (error) {
                _this10.tabLoading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 5:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/edit/".concat(id));
    },
    handleTabClick: function handleTabClick(tab, event) {
      console.log('tab', tab);
      console.log('tab event', event);
    },
    handleChange: function handleChange(val) {
      var _this11 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee1() {
        var id, type, token, i;
        return (0, _regenerator2.default)().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _this11.scoreData = [];
              _this11.raterData = {};
              _this11.didWell = '';
              _this11.forImprovement = '';
              _this11.commentData = {};
              if (!(val === '')) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              // Skip for empty user UUID
              id = typeof _this11.$route.params.id === 'undefined' ? '' : _this11.$route.params.id;
              type = _this11.$route.query.type === 'benchmark' ? 'benchmark' : 'summit';
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this11.tabLoading = true;
              i = 0;
            case 2:
              if (!(i < _this11.stages.length)) {
                _context1.n = 6;
                break;
              }
              if (!(_this11.hike.skillCompassDimensions === "auto")) {
                _context1.n = 4;
                break;
              }
              _context1.n = 3;
              return (0, _hike.scoreCheckingReportNew)(token, id, _this11.stages[i].id, val, type).then(function (response) {
                var userScore = response.data;
                var tmpVideoScore = [];
                if (userScore) {
                  // console.log(userScore)
                  _this11.autoOverallTagsTitle = "Overall " + _this11.hike.report.scoreConfig.overall.length + " factor(s)";
                  _this11.autoOverallTagList = _this11.hike.report.scoreConfig.overall;
                  _this11.autoVideoTagsTitle = "Video " + _this11.hike.report.scoreConfig.video.length + " factor(s)";
                  _this11.autoVideoTagsList = _this11.hike.report.scoreConfig.video;
                  _this11.didWell = userScore.didWell;
                  _this11.forImprovement = userScore.forImprovement;
                  _this11.commentData = {
                    'id': userScore['userHikeReportId'],
                    'userUuid': userScore.uuid
                  };
                  console.log('userScore', userScore);
                  for (var j = 0; j < userScore.videoScores.length; j++) {
                    var scoreGot = 0;
                    var producerAlreadyGiveScore = false;
                    if (userScore.videoScores[j].scores) {
                      scoreGot = userScore.videoScores[j].scores.length;
                      // console.log('have score result', userScore.videoScores[j].scores)
                      for (var k = 0; k < userScore.videoScores[j].scores.length; k++) {
                        if (userScore.videoScores[j].scores[k].raterId === _this11.uuid) {
                          producerAlreadyGiveScore = true;
                        }
                        _this11.raterData[userScore.videoScores[j].scores[k].raterId] = {
                          'raterName': userScore.videoScores[j].scores[k].rater,
                          'stage': userScore.stage,
                          'type': userScore.type,
                          'userUuid': userScore.uuid
                        };
                        tmpVideoScore.push({
                          actionId: userScore.videoScores[j].actionId,
                          title: userScore.videoScores[j].actionTitle,
                          weight: userScore.videoScores[j].actionWeight,
                          rater: userScore.videoScores[j].scores[k].rater,
                          disableAddScoreActions: true,
                          scoreConfig: userScore.videoScores[j].actionScoreConfig,
                          disablePlayActions: false,
                          playInfo: {
                            'title': userScore.videoScores[j].actionTitle,
                            'content': userScore.videoScores[j].content
                          },
                          disableEditOrDeleteActions: false,
                          actionData: {
                            "hike": _this11.hike,
                            "stage": userScore.stage,
                            "type": userScore.type,
                            "userUuid": userScore.uuid,
                            "raterId": userScore.videoScores[j].scores[k].raterId,
                            "actionId": userScore.videoScores[j].actionId
                          },
                          scoreId: userScore.videoScores[j].scores[k].id,
                          scoreResults: userScore.videoScores[j].scores[k].scores,
                          dialTestAvg: _this11.getDialTestAvg(userScore.videoScores[j].content.id, userScore.videoScores[j].scores[k].raterId, userScore.dialTest),
                          disableDialTestDownloadActions: _this11.getDialTestAvg(userScore.videoScores[j].content.id, userScore.videoScores[j].scores[k].raterId, userScore.dialTest) === "-"
                        });
                      }
                    }
                    for (var _ = 0; _ < userScore.raterTotal - scoreGot; _++) {
                      // console.log('add empty score', userScore.videoScores[j].actionTitle)
                      tmpVideoScore.push({
                        actionId: userScore.videoScores[j].actionId,
                        title: userScore.videoScores[j].actionTitle,
                        weight: userScore.videoScores[j].actionWeight,
                        rater: 'Waiting Score',
                        disableAddScoreActions: typeof userScore.videoScores[j].content === 'undefined' || producerAlreadyGiveScore,
                        scoreConfig: userScore.videoScores[j].actionScoreConfig,
                        disablePlayActions: typeof userScore.videoScores[j].content === 'undefined',
                        playInfo: {
                          'title': userScore.videoScores[j].actionTitle,
                          'content': userScore.videoScores[j].content
                        },
                        disableEditOrDeleteActions: true,
                        actionData: {
                          "hike": _this11.hike,
                          "stage": userScore.stage,
                          "type": userScore.type,
                          "userUuid": userScore.uuid,
                          "actionId": userScore.videoScores[j].actionId,
                          "weight": userScore.videoScores[j].actionWeight
                        },
                        scoreId: '',
                        scoreResults: [],
                        dialTestAvg: "-",
                        disableDialTestDownloadActions: true
                      });
                    }
                  }
                  var overallScoresGot = 0;
                  var overallProducerAlreadyGiveScore = false;
                  if (userScore.overalls) {
                    overallScoresGot = userScore.overalls.length;
                    for (var j = 0; j < userScore.overalls.length; j++) {
                      // console.log('have overall result', userScore.overalls[j].scores)
                      if (userScore.overalls[j].raterId === _this11.uuid) {
                        overallProducerAlreadyGiveScore = true;
                      }
                      tmpVideoScore.push({
                        title: "Overall",
                        weight: "-",
                        rater: userScore.overalls[j].rater,
                        disableAddScoreActions: true,
                        scoreConfig: _this11.hike.report.scoreConfig.overall.map(function (v) {
                          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
                            'enable': true
                          });
                        }),
                        disablePlayActions: true,
                        playInfo: 'undefined',
                        disableEditOrDeleteActions: false,
                        actionData: {
                          "hike": _this11.hike,
                          "stage": userScore.stage,
                          "type": userScore.type,
                          "userUuid": userScore.uuid,
                          "raterId": userScore.overalls[j].raterId,
                          "didWell": userScore.didWell,
                          "forImprovement": userScore.forImprovement
                        },
                        scoreResults: userScore.overalls[j].scores,
                        dialTestAvg: "-",
                        disableDialTestDownloadActions: true
                      });
                    }
                  }
                  for (var _ = 0; _ < userScore.raterTotal - overallScoresGot; _++) {
                    // console.log('add empty score')
                    tmpVideoScore.push({
                      title: "Overall",
                      weight: "-",
                      rater: 'Waiting Score',
                      disableAddScoreActions: overallProducerAlreadyGiveScore,
                      scoreConfig: _this11.hike.report.scoreConfig.overall.map(function (v) {
                        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
                          'enable': true
                        });
                      }),
                      disablePlayActions: true,
                      playInfo: 'undefined',
                      disableEditOrDeleteActions: true,
                      actionData: {
                        "hike": _this11.hike,
                        "stage": userScore.stage,
                        "type": userScore.type,
                        "userUuid": userScore.uuid,
                        "didWell": "",
                        "forImprovement": ""
                      },
                      scoreResults: [],
                      dialTestAvg: "-",
                      disableDialTestDownloadActions: true
                    });
                  }
                  console.log('videoScores at the end', tmpVideoScore);
                  _this11.scoreData.push({
                    stageId: userScore.stage,
                    videoScores: tmpVideoScore
                  });
                }
              }).catch(function (error) {
                _this11.scoreData.push({
                  stageId: _this11.stages[i].id,
                  videoScores: []
                });
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
              });
            case 3:
              _context1.n = 5;
              break;
            case 4:
              _context1.n = 5;
              return (0, _hike.scoreCheckingReport)(token, id, _this11.stages[i].id, val, type).then(function (response) {
                var userScore = response.data;
                var tmpVideoScore = [];
                // console.log('API response', userScore)
                if (userScore) {
                  for (var j = 0; j < userScore.videoScores.length; j++) {
                    var scoreGot = 0;
                    var producerAlreadyGiveScore = false;
                    if (userScore.videoScores[j].scores) {
                      scoreGot = userScore.videoScores[j].scores.length;
                      // console.log('have score result', userScore.videoScores[j].scores)
                      for (var k = 0; k < userScore.videoScores[j].scores.length; k++) {
                        if (userScore.videoScores[j].scores[k].raterId === _this11.uuid) {
                          producerAlreadyGiveScore = true;
                        }
                        tmpVideoScore.push({
                          actionId: userScore.videoScores[j].actionId,
                          title: userScore.videoScores[j].actionTitle,
                          weight: userScore.videoScores[j].actionWeight,
                          rater: userScore.videoScores[j].scores[k].rater,
                          disableAddScoreActions: true,
                          scoreConfig: userScore.videoScores[j].actionScoreConfig,
                          disablePlayActions: false,
                          playInfo: {
                            'title': userScore.videoScores[j].actionTitle,
                            'content': userScore.videoScores[j].content
                          },
                          disableEditOrDeleteActions: false,
                          actionData: {
                            "hike": userScore.hike,
                            "stage": userScore.stage,
                            "type": userScore.type,
                            "userUuid": userScore.uuid,
                            "raterId": userScore.videoScores[j].scores[k].raterId,
                            "actionId": userScore.videoScores[j].actionId
                          },
                          scoreId: userScore.videoScores[j].scores[k].id,
                          scoreResults: userScore.videoScores[j].scores[k].results
                        });
                      }
                    }
                    for (var _ = 0; _ < userScore.raterTotal - scoreGot; _++) {
                      // console.log('add empty score', userScore.videoScores[j].actionTitle)
                      tmpVideoScore.push({
                        actionId: userScore.videoScores[j].actionId,
                        title: userScore.videoScores[j].actionTitle,
                        weight: userScore.videoScores[j].actionWeight,
                        rater: 'Waiting Score',
                        disableAddScoreActions: typeof userScore.videoScores[j].content === 'undefined' || producerAlreadyGiveScore,
                        scoreConfig: userScore.videoScores[j].actionScoreConfig,
                        disablePlayActions: typeof userScore.videoScores[j].content === 'undefined',
                        playInfo: {
                          'title': userScore.videoScores[j].actionTitle,
                          'content': userScore.videoScores[j].content
                        },
                        disableEditOrDeleteActions: true,
                        actionData: {
                          "hike": userScore.hike,
                          "stage": userScore.stage,
                          "type": userScore.type,
                          "userUuid": userScore.uuid,
                          "actionId": userScore.videoScores[j].actionId,
                          "weight": userScore.videoScores[j].actionWeight
                        },
                        scoreId: '',
                        scoreResults: []
                      });
                    }
                  }
                  _this11.scoreData.push({
                    stageId: userScore.stage,
                    videoScores: tmpVideoScore,
                    overallScore: userScore.calculatedScore
                  });
                }
              }).catch(function (error) {
                _this11.scoreData.push({
                  stageId: _this11.stages[i].id,
                  videoScores: []
                });
                (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
              });
            case 5:
              i++;
              _context1.n = 2;
              break;
            case 6:
              _this11.tabLoading = false;
              //console.log('spider data', this.spiderData)
              // console.log('User score', this.scoreData)
            case 7:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    getScoreAndRate: function getScoreAndRate(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      var val = null;
      if (s) {
        val = s.score + ' (' + s.rate + '%)';
      } else {
        val = '-';
      }
      return val;
    },
    getScoreAndRateForAutoType: function getScoreAndRateForAutoType(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      var val = null;
      if (s) {
        val = s.score + ' (' + s.weight + '%)';
      } else {
        val = '-';
      }
      return val;
    },
    getSpiderScore: function getSpiderScore(scores, key) {
      var s = _lodash.default.find(scores, function (s) {
        return s.key === key;
      });
      if (s) {
        return s.score;
      } else {
        return '-';
      }
    },
    getDialTestAvg: function getDialTestAvg(contentId, raterId, dialTest) {
      if (typeof dialTest === 'undefined') {
        return "-";
      }
      if (typeof dialTest.contents === 'undefined') {
        return "-";
      }
      if (dialTest.contents.hasOwnProperty(contentId)) {
        var content = dialTest.contents[contentId];
        var rater = content.raters.find(function (item) {
          return item.rater === raterId;
        });
        if (rater === undefined) {
          return "-";
        } else {
          return (rater.avg * 10).toFixed(1);
        }
      }
      return "-";
    },
    handleDownloadDialTestClick: function handleDownloadDialTestClick(playInfo, actionInfo) {
      var _this12 = this;
      this.$confirm("This Dialtest will be downloaded. Continue?", 'Info', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(function () {
        _this12.downloadDialTest(actionInfo, playInfo.content.id);
      }).catch(function () {
        var msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    downloadDialTestToExcel: function downloadDialTestToExcel(result) {
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var tHeader = ['Second', 'EmojiType', 'Score'];
        var excelData = [];
        for (var i = 0; i < result.length; i++) {
          var row = [];
          row.push(result[i].second);
          row.push(result[i].emojiType);
          row.push(result[i].score);
          excelData.push(row);
        }
        excel.export_json_to_excel({
          header: tHeader,
          data: excelData,
          filename: "Hike DialTest",
          autoWidth: true,
          bookType: 'xlsx'
        });
        (0, _log.displayPopupMessage)("Dialtest data has been downloaded successfully!", 'success');
      });
    },
    downloadDialTest: function downloadDialTest(actionInfo, contentId) {
      var _this13 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee10() {
        var token;
        return (0, _regenerator2.default)().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _context10.n = 1;
              return (0, _hike.getDialTestData)(token, actionInfo.hike.id, actionInfo.stage, actionInfo.userUuid, contentId, actionInfo.raterId).then(function (response) {
                var data = response.data;
                var result = data.record.result;
                _this13.downloadDialTestToExcel(result);
              }).catch(function (error) {
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    sortHikeTeams: function sortHikeTeams() {
      var HikeTeams = this.myHikeTeams;
      console.info(JSON.stringify(HikeTeams));
      var sort = this.sort;
      if (sort) {
        this.sort = !sort;
        //this.myHikeTeams= _.orderBy(HikeTeams,['givenName'], ['desc']);
        this.myHikeTeams = _lodash.default.orderBy(HikeTeams, [function (hiketeam) {
          return hiketeam.givenName.toLowerCase();
        }, function (hiketeam) {
          return hiketeam.familyName.toLowerCase();
        }, function (hiketeam) {
          return hiketeam.email.toLowerCase();
        }], ['desc']);
      } else {
        this.sort = !sort;
        //this.myHikeTeams= _.orderBy(HikeTeams,['givenName'], ['asc']);
        this.myHikeTeams = _lodash.default.orderBy(HikeTeams, [function (hiketeam) {
          return hiketeam.givenName.toLowerCase();
        }, function (hiketeam) {
          return hiketeam.familyName.toLowerCase();
        }, function (hiketeam) {
          return hiketeam.email.toLowerCase();
        }], ['asc']);
      }
    }
  }
};